/**
 * Page Dynamic Editor link parameters wrapper
 */

const NEW_NAME  = 'PageDynamicEditorNew'
const EDIT_NAME = 'PageDynamicEditor'

export default new class {

  constructor () {
    this._target    = null
    this._redir     = 'self'
    this._defaults  = null
    this._hash      = null
    this._parent    = null
    this._parentDef = null
  }

  /**
   *
   * @return {string}
   */
  get targetNewName () {
    return NEW_NAME
  }

  /**
   *
   * @return {string}
   */
  get targetEditName () {
    return EDIT_NAME
  }

  /**
   *
   * @param value
   */
  set target (value) {
    this._target = value
  }

  /**
   *
   * @param value
   */
  set defaults (value) {
    this._defaults = value
  }

  /**
   *
   * @param value
   */
  set redir (value) {
    this._redir = value
  }

  /**
   *
   * @return {string|*}
   */
  get redir () {
    return this._redir
  }

  /**
   *
   * @param value
   */
  set hash (value) {
    this._hash = value
  }

  /**
   *
   * @param value
   */
  set parent (value) {
    this._parent = value
  }

  set parentDef (value) {
    this._parentDef = value
  }

  /**
   *
   * @param def Definition
   * @return {{name: string, params: {businessRules: {delrec: *, valrec: *,
   *   calrec: *, newrec: *}, idStructure: *, def: *, page: *}}}
   */
  getParams (def) {
    let params   = {

          // parametry v url
          page:        def.field,
          idStructure: def.idtEStrctr,

          // ostatni predavane parametry
          propDef: def
        },
        defaults = {},
        target   = this.targetEditName,
        redir    = this.redir

    if (this._target) {
      target       = this._target
      this._target = null
    }

    if (this._redir) {
      redir        = this._redir
      this._redir  = 'self'
      params.redir = redir
    }
    else {
      params.redir = 'self'
    }

    if (this._defaults) {
      defaults       = this._defaults
      this._defaults = null
    }

    if (defaults.hasOwnProperty('ID')) {
      params.id = defaults.ID
    }

    params.defaults = defaults

    let outputParams = { name: target, params: params }

    if (this._hash) {
      outputParams.hash = this._hash
      this._hash        = null
    }

    if (this._parent) {
      outputParams.params.parent = this._parent
      this._parent               = null
    }

    if (this._parentDef) {
      outputParams.params.parentDef = this._parentDef
      this._parentDef               = null
    }

    return outputParams
  }

}()
